import React,{useEffect, useRef} from 'react'
import "./About.css"
import {profile2} from '../../images'
import gsap from 'gsap'
import {ScrollTrigger} from 'gsap/ScrollTrigger'


const About = () => {
  const container = useRef(null);
  //Register plugin
  gsap.registerPlugin(ScrollTrigger);
  useEffect(()=>{
    const el = container.current;
    gsap.fromTo('.about__container',{
      scale:0.7,
    },
    {
      scale:1,
      scrollTrigger:{
        trigger:el,
        scrub:true,
        markers:false,
      }
    }
  )
  },[])
  




  return (
    <section ref={container} id='about'>
      <div className="section__wrapper about__container">
          <div className="me__container blur-effect">
              <div className="photo__container">
                 <img src={profile2} alt="" />
              </div>
          </div>
          <div className="section__header">
              <h4 className='primary__title'>ABOUT ME</h4>
              <h1 className='title'>𝗜 𝗮𝗺 <span className='color__primary'>𝗢𝗞𝗔𝗕𝗘 𝗥𝗜𝗡𝗧𝗔𝗥𝗢𝗨</span></h1>
              <p className="text__muted description">
                I’m a complex character who, despite my mad scientist persona, deeply cares for others and strives to help them. I was once an ordinary university student in Akihabara before I stumbled upon the mysteries of time travel. After encountering the profound consequences of my actions, I embarked on a journey to protect those I care about and avert the tragedies threatening our reality....
               <br />
               <br />
                A 17-year-old university student who finds himself thrust into the chaotic world of time travel. Initially unaware of the full scope of his abilities, he relies on his intellect to navigate the challenges. As he forges strong connections with those around him, he must confront his own flaws and harness his newfound knowledge to protect the people he cares about from various threats.
               <br />
               <br />
                Personality: Initially, I may appear as an eccentric and self-focused individual. However, after delving into the complexities of time travel and facing numerous challenges, I become more determined and empathetic. I am prepared to sacrifice myself for others and to battle for what I believe in.
               <br />
               <br />
              </p>
              <a href="https://telegram.me/Its_Oreki_Hotarou" className="btn btn__primary">Read more</a>
          </div>
      </div>
    </section>
  )
}

export default About
